/**
 * XNails — Lazy load iframes (videos) using IntersectionObserver.
 * Iframes with class="lazy" and data-src will load when scrolled into view.
 */
(function () {
  "use strict";

  function loadIframe(iframe) {
    var src = iframe.getAttribute("data-src");
    if (src) {
      iframe.setAttribute("src", src);
      iframe.removeAttribute("data-src");
      iframe.classList.remove("lazy");
    }
  }

  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadIframe(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "200px" }
    );

    document.querySelectorAll("iframe.lazy").forEach(function (iframe) {
      observer.observe(iframe);
    });
  } else {
    document.querySelectorAll("iframe.lazy").forEach(loadIframe);
  }
})();
